<template>
  <header class="view-header">
    <div class="checkin-detail-header">
      <div class="row-small-gutters">
        <div class="col-12 col-lg">
          <div class="event-summary">
            <div class="d-lg-flex justify-content-between">
              <div
                  class="d-flex justify-content-between justify-content-lg-start align-items-start w-100 w-lg-auto">
                <div class="d-flex align-items-center w-100 w-lg-auto">
                  <div class="event-summary__logo" v-if="checkin.event_cover">
                    <img :src="checkin.event_cover" alt="Event logo">
                  </div>
                  <div class="w-100 w-lg-auto">
                    <div class="d-flex justify-content-between align-items-start">
                      <div>
                        <h1 class="event-summary__name">{{ eventName }}</h1>
                        <div class="d-flex align-items-baseline">
                          <div>
                            <div class="event-status__icon" v-if="!isTaggingCompleted"></div>
                          </div>
                          <h6 class="event-summary__subname">{{ checkin.event_subtitle }}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="hasFaces">
            <div class="d-flex justify-content-start flex-wrap mt-4 mb-2">
              <CheckinFaceList @click="openFaceRecognitionModal()" :checkin-faces="checkin.checkin_faces"
                               :max-faces-count="checkin.max_faces_count"
                               :disabled="checkin.checkin_faces.length === checkin.max_faces_count"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>


<script>


import CheckinFaceList from "@/components/CheckinFaceList.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CheckinSummary",
  components: {CheckinFaceList},
  computed: {

    ...mapGetters('checkinDetail', [
      'checkin',
      'picaCode',
      'isTaggingCompleted',
      'picaServiceId',
      'eventName',
    ]),
    hasFaces() {
      return this.checkin.max_faces_count > 1 && this.checkin.checkin_faces.length > 0
    }
  },
  methods: {
    ...mapActions('checkin', [
      'openAddSelfieStep'
    ]),
    openFaceRecognitionModal(recognitionFallbackMode = false) {
      this.openAddSelfieStep({
        checkin: {id: this.checkin.id, picacode: this.checkin.picacode},
        max_faces_count: this.checkin.max_faces_count,
        checkin_faces: this.checkin.checkin_faces,
        user_cta: this.checkin.user_cta,
        liveness_detection_enabled: this.checkin.liveness_detection_enabled,
        stay_mode: null,
        face_checkin_privacy_statement: null,
        callback: (checkinId, newCheckinFaces, faceCheckinComplete = false) => {
          if (checkinId === this.checkin.id) {
            this.$set(this.checkin, 'checkin_faces', newCheckinFaces)
          }

          if (recognitionFallbackMode && faceCheckinComplete) {
            this.hideUserCta = true
          }

          if (this.anonymizing) {
            this.$refs.modalAnonymizeCheckin.takeAction()
            this.anonymizing = false
          }
        }
      })
    },
  }

}
</script>